import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/school/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param searchSkiSchoolPrices
   * @returns {AxiosPromise}
   */
  searchAvailableSkiSchoolPrices(searchSkiSchoolPrices) {
    return conduit.post('search-available-prices', { searchSkiSchoolPrices });
  },

  /**
   * @param twentyAreaId
   * @returns {AxiosPromise}
   */
  loadSkiSchoolMeetingPointsByTwentyAreaId(twentyAreaId) {
    return conduit.get(`area/${twentyAreaId}/meeting-points`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-school-service.js